import React, { useRef } from 'react';
import logo from './logo.svg';
import './App.css';
import { AnimatePresence, motion, MotionValue, useMotionValue, useScroll, useSpring, useTransform } from "framer-motion";
import { useState } from 'react';


function App() {

  // 페이지 스크롤 진행률 (0 ~ 1)
  const { scrollYProgress } = useScroll();

  // 부드럽게(스프링) 보간
  const pathProgress = useSpring(scrollYProgress, { stiffness: 120, damping: 20 });

  return (
    <div style={{ minHeight: "200vh"}}>
      <h2>스크롤을 내려보세요</h2>

      

      <svg viewBox="0 0 100wh 200vh" width="100%" height="200vh" style={{position:"fixed"}}>
        
        <motion.path 
        
        d="M84,47s-125,134,18,254,375-83,267-86S-15,315,160,455s390,89,337,211-301,150-301,150"
        fill="none"
        stroke="#231f20"
        height={200}
        strokeMiterlimit={10}
        style={{ pathLength: pathProgress }}
        />

      </svg>

      <p style={{ marginTop: 1000 }}>끝!</p>
    </div>
  );
}

export default App;
